<template>
  <v-container fluid>
    <v-data-table :headers="headers" class="elevation-1" :items="contas" :loading="loading">
      <template v-slot:top>
        <v-toolbar flat>
          <datatable-filters :filters="filters" v-model="filtrosAtivos"></datatable-filters>
          <v-divider vertical inset class="mx-4" />
          <v-spacer />
          <v-btn
            depressed
            color="accent" 
            :to="{ name: 'conta-bancaria-formulario' }" 
            v-if="
                perms.includes('contabancaria.criar_contas')
            "
          >
            <v-icon class="mr-2">mdi-bank-plus</v-icon>NOVO CADASTRO
          </v-btn>
        </v-toolbar>
      </template>
      <template
        v-slot:item.banco="{ item }"
      >{{item.banco ? `${item.banco.codigo} - ${item.banco.nome}` : ''}}</template>
      <template
        v-slot:item.ids_forma_pagamento="{ item }"
      >{{ item.formas_pagamento.map((f) => f.descricao).join(", ") }}</template>
      <template v-slot:item.actions="{ item }">
        <v-btn v-if="perms.includes('contabancaria.editar_contas')" icon small text @click="editar(item.id)">
          <v-icon class="mdi mdi-pencil" small />
        </v-btn>
        <dialog-confirm
          titulo="Deletar Conta Bancária"
          texto="Confirma a exclusão?"
          @confirmar="deletar(item.id)"
          v-if="perms.includes('contabancaria.excluir_contas')"
        >
          <v-btn icon small text>
            <v-icon class="mdi mdi-delete" small />
          </v-btn>
        </dialog-confirm>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import DialogConfirm from "../components/DialogConfirm";
import DatatableFilters from "../components/DatatableFilters";
export default {
  components: { DialogConfirm, DatatableFilters },
  data() {
    return {
      headers: [
        { text: "Descrição", value: "descricao" },
        { text: "Empresa", value: "empresa.nome_fantasia" },
        { text: "Banco", value: "banco" },
        { text: "Agência", value: "agencia" },
        { text: "Conta", value: "conta" },
        { text: "Formas de pagamento", value: "ids_forma_pagamento" },
        { text: "Ações", value: "actions", sortable: false, align: "center" }
      ],
      loading: false,
      dialogConfirm: false,
      filters: [
        {
          name: "id_empresa",
          label: "Empresa",
          type: "select",
          options: []
        },
        {
          name: "ids_forma_pagamento",
          label: "Formas de pagamento",
          type: "select",
          multiple: true,
          options: []
        }
      ],
      filtrosAtivos: JSON.parse(
        localStorage.getItem("filtros.contas-bancarias") || "{}"
      )
    };
  },
  computed: {
    ...mapState({
      perms: (state) => state.usuarios.usuarioAtivo.permissoes,
    }),
    contas() {
      return this.$store.state.contaBancaria.contasBancarias;
    }
  },
  methods: {
    async listar() {
      this.loading = true;
      try {
        const opts = {
          filtros: this.filtrosAtivos,
          carregarTudo: true
        };
        await this.$store.dispatch("contaBancaria/listar", opts);
      } catch (err) {
        console.log(err);
        this.$store.commit("ui/setSnackbar", {
          text: "Não foi possível carregar a lista de contas bancárias"
        });
      }
      this.loading = false;
    },
    async deletar(id) {
      await this.$store.dispatch("contaBancaria/deletar", { id });

      this.listar();
    },
    editar(id) {
      this.$router.replace({
        path: "editar",
        name: "conta-bancaria-formulario-editar",
        params: { id }
      });
    }
  },
  mounted() {
    this.$store.commit("ui/changeToolbar", {
      title: "Cadastro de contas bancárias"
    });
    this.$store.dispatch("formaPgto/listar", {}).then(formas => {
      this.filters.find(
        f => f.name === "ids_forma_pagamento"
      ).options = formas.data.map(f => ({
        text: f.descricao,
        value: f.id
      }));
    });
    this.$store.dispatch("empresa/listar", {}).then(empresas => {
      this.filters.find(
        f => f.name === "id_empresa"
      ).options = empresas.data.map(e => ({
        text: e.nome_fantasia,
        value: e.id
      }));
    });
    this.listar();
  },
  watch: {
    filtrosAtivos(val) {
      localStorage.setItem("filtros.contas-bancarias", JSON.stringify(val));
      this.listar();
    }
  }
};
</script>
